var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.signature?.url)?_c('img',{staticClass:"form-submission-card--signature img-fluid",attrs:{"src":_vm.signature.url,"alt":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }